import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

interface OverlayProps {
  text: string;
  children: React.ReactNode;
}

const Overlay: React.FC<OverlayProps> = ({ text, children }) => {
  const renderTooltip = <Popover id="popover-basic">{text}</Popover>;

  return (
    <OverlayTrigger placement="top" overlay={renderTooltip}>
      {children}
    </OverlayTrigger>
  );
};

export default Overlay;
